import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import {
  Field,
  Form,
  Formik,
} from 'formik';
import {
  Row,
  Col,
  ControlLabel,
  FormGroup,
  FormControl,
  Alert,
  Button,
  InputGroup,
} from 'react-bootstrap';
import LoadingButton from '../../components/LoadingButton/LoadingButton';
import {
  Portlet,
  PortletBody,
  PortletCaption,
  PortletTitle,
} from '../../components/Bootstrap/Portlet';
import { withTranslation } from 'react-i18next';

@inject('dischargeStore')
@observer
class LoadSizeChargeForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
    };
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  initialValues = () => {
    return {
      loadSize: null,
      dischargeSequenceId: null,
      rate: null,
    };
  };

  render() {
    const { dischargeStore, t } = this.props;
    const { sequences, loadSizeChargeId, loadSizeCharge } = dischargeStore;

    const onCancel = () => {
      dischargeStore.selectLoadSizeCharge();
    };

    return (
      <Portlet>
        <PortletTitle>
          <PortletCaption>{loadSizeChargeId > 0 ? t('Edit Load Size Charge', {loadSizeChargeId}) : t('New Load Size Charge')}</PortletCaption>
        </PortletTitle>
        <PortletBody>
          <Formik
            enableReinitialize
            initialValues={
              loadSizeChargeId > 0
                ? loadSizeCharge.find(v => v.id === loadSizeChargeId)
                : this.initialValues()
            }
            onSubmit={(values, actions) => {
              this.setState({
                error: null,
              });

              let promise;
              if (values.id > 0) {
                promise = dischargeStore.updateLoadSizeCharge(values);
              } else {
                promise = dischargeStore.addLoadSizeCharge(values);
              }

              promise.then(() => {
                if (!this.mounted) {
                  return;
                }

                actions.setSubmitting(false);
                dischargeStore.selectLoadSizeCharge();
              }).catch(e => {
                if (!this.mounted) {
                  return;
                }

                actions.setSubmitting(false);
                this.setState({
                  error: `${e.message}`,
                });
              });

            }
            }
          >{({ handleChange,
              values,
              isSubmitting,
            }) => (
              <Form className={'load-size-charge-form'}>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <ControlLabel>{t('Load Size')}</ControlLabel>
                      <InputGroup>
                        <Field name="loadSize"
                          type="number"
                          required={true}
                          value={values?.loadSize || ''}
                          onChange={handleChange}
                          className="form-control input-sm" />
                        <InputGroup.Addon>{t('unit')} / {t('sec')}</InputGroup.Addon>
                      </InputGroup>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <ControlLabel>{t('Sequence')}</ControlLabel>
                      <FormControl
                        name="dischargeSequenceId"
                        componentClass="select"
                        required={true}
                        value={values.dischargeSequenceId || ''}
                        onChange={handleChange}
                        bsSize="sm"
                      >
                        <option value="" />
                        {sequences.map(option => (
                          <option key={option.id} value={option.id}>
                            {option.name ? `${option.name}` : `#${option.id}`}
                          </option>
                        ))}
                      </FormControl>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <ControlLabel>{t('Default Rate')}</ControlLabel>
                      <InputGroup>
                        <Field name="rate"
                          type="number"
                          value={values.rate || ''}
                          onChange={handleChange}
                          className="form-control input-sm" />
                        <InputGroup.Addon>{t('unit')} / {t('sec')}</InputGroup.Addon>
                      </InputGroup>
                    </FormGroup>
                  </Col>
                  <Col sm={12} className="text-right">
                    {!!this.state.error && <Alert bsStyle="danger">{this.state.error}</Alert>}
                    <Button onClick={onCancel}>{t('Cancel')}</Button>
                    {' '}
                    <LoadingButton
                      bsStyle="primary"
                      type="submit"
                      label={t('Save')}
                      loadingLabel={t('Saving')}
                      isLoading={isSubmitting}
                    />
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </PortletBody>
      </Portlet>
    );
  }
}

export default withTranslation()(LoadSizeChargeForm);
